// Singleton for storing browser methods:
export default class BCMSWebAgent {

  // :: VOID -> {STRING:STRING}
  // Returns key/value pair of query parameters from search string of window location
  // NOTE: Returns empty object if no parameters are found:
  static queryParams() {
    let queryVar = window.location.search;
    return queryVar.slice(1).split("&").reduce((result, param) => {
        let [key, value] = param.split("=");
        result[key] = value;
        return result;
    }, {})
  }

  // :: VOID -> STRING
  // Returns URL of model to use for demo:
  static getModelURL() {
    let {b,c} = BCMSWebAgent.queryParams();
    let modelPath = "/bcms/php/deploy/DemoModel.php";
    let protocol = window.location.protocol;
    let domain = window.location.host;
    return `${protocol + "//" + domain + modelPath}?b=${b}&c=${c}`;
  }

  // :: STRING, STRING, NUMBER -> VOID
  // Create new cookie using the given name, value, and expiration (in milliseconds)
  static setCookie (name, value, expires) {
    document.cookie = expires === undefined
      ? name+"="+value+"; path=/"
      : name+"="+value+"; expires="+expires+"; path=/";
  }

  // STRING -> STRING|VOID
  // Returns cookie value for a given cookie name:
  static getCookieValue (name) {
    let cookies = document.cookie.split('; ');
    for (let i=0; i < cookies.length; i++) {
      let cookie = cookies[i],
          delimiter = cookie.indexOf('='),
          cookieName = cookie.substring(0, delimiter),
          cookieData = cookie.substring(delimiter + 1);
      if (cookieName === name) {
        return cookieData;
      }
    }
    return undefined;
  }


}
